// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ul {
  text-align: start;
  line-height: 1.6rem;
  font-family: "Helvetica";
  font-weight: 400;
  padding: 2%;
  margin-bottom: 0rem;
}

li .ulBottomBorder {
  margin-bottom: 10px;
}

.no-border {
  border-bottom: none;
}

.successStories1Card {
  height: 43vh;
  min-height: 20vh;
  width: 100vw;
  border-color: rgba(240, 89, 42, 0.2392156863);
  border-radius: 20px;
  background-color: #020c2e;
}
.successStories1Card_list {
  font-family: Roboto;
  font-weight: 400;
  font-size: 1.1vw;
  padding: 0vw 1.5vw;
  color: var(--white, #fff);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5vw;
  margin-bottom: 0rem;
}
.successStories1Card_card {
  padding: 1rem;
  width: 100%;
}
.successStories1Card_cardCol {
  display: flex;
  justify-content: center;
}

.successStories1Card .ant-card-head {
  border-radius: 20px 20px 0px 0px;
  background: var(--gradient-blue-orange, linear-gradient(137deg, #ffb6a0 0%, #f0592a 18.54%, #253c77 100%));
  color: #fff;
  min-height: 56px;
}

ul.successStories1Card_list li {
  list-style: none;
  margin-bottom: 10px;
  line-height: 1.5vw;
}

.successStories1Card .ant-card-head-title {
  font-size: 1.5vw;
  color: #fff;
  font-family: Roboto;
  font-style: normal;
  font-weight: 700;
  line-height: 1.5vw;
  padding: 1vw;
}

.successStories1Card .ant-card-body {
  border-color: #f0592a;
  background-color: #020c2e;
  padding: 1.3vw 0vw 0vw 0vw;
  border-radius: 0px 0px 20px 20px;
}

.successStories1Card .ant-card-bordered {
  border-radius: 20px;
}

@media only screen and (min-width: 1388px) and (max-width: 2561px) {
  .successStories1Card {
    height: 50vh;
  }
  .successStories1Card_list {
    font-size: 1vw;
  }
  .successStories1Card_card {
    width: 100%;
  }
  .successStories1Card .ant-card-head {
    font-size: 3vw;
    line-height: 4vw;
    min-height: 70px;
  }
}
@media only screen and (max-width: 1026px) {
  .successStories1Card {
    height: 67vh;
    width: 80vw;
  }
  .successStories1Card_list {
    font-size: 1.7vw;
  }
  .successStories1Card .ant-card-head-title {
    font-size: 2vw;
    line-height: 2.5vw;
  }
  ul.successStories1Card_list li {
    list-style: none;
    margin-bottom: 10px;
    line-height: 2.2vw;
  }
}
@media only screen and (max-width: 321px) {
  .successStories1Card {
    height: 60vh;
    width: 100vw;
  }
  .successStories1Card_list {
    font-size: 3.8vw;
    padding: 0vw 4vw;
    line-height: 3.2vw !important;
  }
  .successStories1Card .ant-card-head-title {
    font-size: 5vw;
    line-height: 5vw;
  }
  ul.successStories1Card_list li {
    list-style: none;
    margin-bottom: 7px;
    line-height: 5vw;
  }
  .successStories1Card .ant-card-body {
    padding: 4vw 0vw 0vw 0vw;
  }
}
@media only screen and (min-width: 321px) and (max-width: 576px) {
  .successStories1Card {
    height: 50vh;
    width: 100vw;
  }
  .successStories1Card_list {
    font-size: 4vw;
    line-height: 5vw;
    padding: 0vw 4vw;
  }
  .successStories1Card .ant-card-head-title {
    font-size: 4vw;
    line-height: 5vw;
  }
  ul.successStories1Card_list li {
    list-style: none;
    margin-bottom: 10px;
    line-height: 4.8vw;
  }
  .successStories1Card .ant-card-body {
    padding: 3vw 0vw 0vw 0vw;
  }
}
@media only screen and (min-width: 576px) and (max-width: 767px) {
  .successStories1Card {
    height: 75vh;
    width: 100vw;
  }
  .successStories1Card_list {
    font-size: 3.5vw;
    line-height: 5vw;
    padding: 0vw 4vw;
  }
  .successStories1Card .ant-card-head-title {
    font-size: 4vw;
    line-height: 5vw;
  }
  ul.successStories1Card_list li {
    list-style: none;
    margin-bottom: 10px;
    line-height: 4.8vw;
  }
  .successStories1Card .ant-card-body {
    padding: 3vw 0vw 0vw 0vw;
  }
}
@media only screen and (min-width: 767px) and (max-width: 992px) {
  .successStories1Card {
    height: 45vw;
    width: 80vw;
  }
  .successStories1Card_list {
    font-size: 1.7vw;
  }
  .successStories1Card .ant-card-head-title {
    font-size: 2vw;
    line-height: 2.5vw;
  }
  ul.successStories1Card_list li {
    list-style: none;
    margin-bottom: 10px;
    line-height: 2.2vw;
  }
}
@media only screen and (min-width: 1026px) and (max-width: 1388px) {
  .successStories1Card {
    height: 55vh;
    width: 100vw;
  }
  .successStories1Card_list {
    font-size: 1.4vw;
    line-height: 1.7vw;
    padding: 0vw 2vw;
  }
  .successStories1Card .ant-card-head-title {
    font-size: 2vw;
    line-height: 2vw;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/SuccessStories1Card/successStories1Card.scss"],"names":[],"mappings":"AACA;EACE,iBAAA;EACA,mBAAA;EACA,wBAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;AAAF;;AAEA;EAEE,mBAAA;AAAF;;AAEA;EACE,mBAAA;AACF;;AACA;EACE,YAAA;EACA,gBAAA;EACA,YAAA;EACA,6CAAA;EACA,mBAAA;EACA,yBAAA;AAEF;AAAE;EACE,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AAEJ;AACE;EACE,aAAA;EACA,WAAA;AACJ;AAEE;EACE,aAAA;EACA,uBAAA;AAAJ;;AAIA;EACE,gCAAA;EACA,0GAAA;EAIA,WAAA;EACA,gBAAA;AAJF;;AAMA;EACE,gBAAA;EACA,mBAAA;EACA,kBAAA;AAHF;;AAKA;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;AAFF;;AAKA;EACE,qBAAA;EACA,yBAAA;EACA,0BAAA;EACA,gCAAA;AAFF;;AAKA;EACE,mBAAA;AAFF;;AAIA;EACE;IACE,YAAA;EADF;EAGE;IACE,cAAA;EADJ;EAIE;IACE,WAAA;EAFJ;EAKA;IACE,cAAA;IACA,gBAAA;IACA,gBAAA;EAHF;AACF;AAKA;EACE;IACE,YAAA;IACA,WAAA;EAHF;EAMA;IACE,gBAAA;EAJF;EAMA;IACE,cAAA;IACA,kBAAA;EAJF;EAMA;IACE,gBAAA;IACA,mBAAA;IACA,kBAAA;EAJF;AACF;AAMA;EACE;IACE,YAAA;IACA,YAAA;EAJF;EAOA;IACE,gBAAA;IACA,gBAAA;IACA,6BAAA;EALF;EAOA;IACE,cAAA;IACA,gBAAA;EALF;EAOA;IACE,gBAAA;IACA,kBAAA;IACA,gBAAA;EALF;EAOA;IACE,wBAAA;EALF;AACF;AAOA;EACE;IACE,YAAA;IACA,YAAA;EALF;EAOA;IACE,cAAA;IACA,gBAAA;IACA,gBAAA;EALF;EAOA;IACE,cAAA;IACA,gBAAA;EALF;EAOA;IACE,gBAAA;IACA,mBAAA;IACA,kBAAA;EALF;EAOA;IACE,wBAAA;EALF;AACF;AAQA;EACE;IACE,YAAA;IACA,YAAA;EANF;EAQA;IACE,gBAAA;IACA,gBAAA;IACA,gBAAA;EANF;EAQA;IACE,cAAA;IACA,gBAAA;EANF;EAQA;IACE,gBAAA;IACA,mBAAA;IACA,kBAAA;EANF;EAQA;IACE,wBAAA;EANF;AACF;AASA;EACE;IACE,YAAA;IACA,WAAA;EAPF;EAUA;IACE,gBAAA;EARF;EAUA;IACE,cAAA;IACA,kBAAA;EARF;EAUA;IACE,gBAAA;IACA,mBAAA;IACA,kBAAA;EARF;AACF;AAWA;EACE;IACE,YAAA;IACA,YAAA;EATF;EAYA;IACE,gBAAA;IACA,kBAAA;IACA,gBAAA;EAVF;EAYA;IACE,cAAA;IACA,gBAAA;EAVF;AACF","sourcesContent":["\nul {\n  text-align: start;\n  line-height: 1.6rem;\n  font-family: \"Helvetica\";\n  font-weight: 400;\n  padding: 2%;\n  margin-bottom: 0rem;\n}\nli .ulBottomBorder {\n \n  margin-bottom: 10px;\n}\n.no-border {\n  border-bottom: none;\n}\n.successStories1Card {\n  height: 43vh;\n  min-height: 20vh;\n  width: 100vw;\n  border-color: #f0592a3d;\n  border-radius: 20px;\n  background-color: #020c2e;\n\n  &_list {\n    font-family: Roboto;\n    font-weight: 400;\n    font-size: 1.1vw;\n    padding: 0vw 1.5vw;\n    color: var(--white, #fff);\n    font-style: normal;\n    font-weight: 400;\n    line-height: 1.5vw;\n    margin-bottom: 0rem;\n  }\n\n  &_card {\n    padding: 1rem;\n    width: 100%;\n  }\n\n  &_cardCol {\n    display: flex;\n    justify-content: center;\n  }\n}\n\n.successStories1Card .ant-card-head {\n  border-radius: 20px 20px 0px 0px;\n  background: var(\n    --gradient-blue-orange,\n    linear-gradient(137deg, #ffb6a0 0%, #f0592a 18.54%, #253c77 100%)\n  );\n  color: #fff;\n  min-height: 56px;\n}\nul.successStories1Card_list li {\n  list-style: none;\n  margin-bottom: 10px;\n  line-height: 1.5vw;\n}\n.successStories1Card .ant-card-head-title {\n  font-size: 1.5vw;\n  color: #fff;\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 1.5vw;\n  padding: 1vw;\n}\n\n.successStories1Card .ant-card-body {\n  border-color: #f0592a;\n  background-color: #020c2e;\n  padding: 1.3vw 0vw 0vw 0vw;\n  border-radius: 0px 0px 20px 20px;\n}\n\n.successStories1Card .ant-card-bordered {\n  border-radius: 20px;\n}\n@media only screen and (min-width: 1388px) and (max-width:2561px) {\n  .successStories1Card {\n    height: 50vh;\n\n    &_list {\n      font-size: 1vw;\n    }\n\n    &_card {\n      width: 100%;\n    }\n  }\n  .successStories1Card .ant-card-head {\n    font-size: 3vw;\n    line-height: 4vw;\n    min-height: 70px;\n  }\n}\n@media only screen and (max-width: 1026px) {\n  .successStories1Card {\n    height: 67vh;\n    width: 80vw;\n  }\n\n  .successStories1Card_list {\n    font-size: 1.7vw;\n  }\n  .successStories1Card .ant-card-head-title {\n    font-size: 2vw;\n    line-height: 2.5vw;\n  }\n  ul.successStories1Card_list li {\n    list-style: none;\n    margin-bottom: 10px;\n    line-height: 2.2vw;\n  }\n}\n@media only screen and (max-width: 321px) {\n  .successStories1Card {\n    height: 60vh;\n    width: 100vw;\n  }\n\n  .successStories1Card_list {\n    font-size: 3.8vw;\n    padding: 0vw 4vw;\n    line-height: 3.2vw !important;\n  }\n  .successStories1Card .ant-card-head-title {\n    font-size: 5vw;\n    line-height: 5vw;\n  }\n  ul.successStories1Card_list li {\n    list-style: none;\n    margin-bottom: 7px;\n    line-height: 5vw;\n  }\n  .successStories1Card .ant-card-body {\n    padding: 4vw 0vw 0vw 0vw;\n  }\n}\n@media only screen and (min-width: 321px) and (max-width: 576px) {\n  .successStories1Card {\n    height: 50vh;\n    width: 100vw;\n  }\n  .successStories1Card_list {\n    font-size: 4vw;\n    line-height: 5vw;\n    padding: 0vw 4vw;\n  }\n  .successStories1Card .ant-card-head-title {\n    font-size: 4vw;\n    line-height: 5vw;\n  }\n  ul.successStories1Card_list li {\n    list-style: none;\n    margin-bottom: 10px;\n    line-height: 4.8vw;\n  }\n  .successStories1Card .ant-card-body {\n    padding: 3vw 0vw 0vw 0vw;\n  }\n}\n\n@media only screen and (min-width: 576px) and (max-width: 767px) {\n  .successStories1Card {\n    height: 75vh;\n    width: 100vw;\n  }\n  .successStories1Card_list {\n    font-size: 3.5vw;\n    line-height: 5vw;\n    padding: 0vw 4vw;\n  }\n  .successStories1Card .ant-card-head-title {\n    font-size: 4vw;\n    line-height: 5vw;\n  }\n  ul.successStories1Card_list li {\n    list-style: none;\n    margin-bottom: 10px;\n    line-height: 4.8vw;\n  }\n  .successStories1Card .ant-card-body {\n    padding: 3vw 0vw 0vw 0vw;\n  }\n}\n\n@media only screen and (min-width: 767px) and (max-width: 992px) {\n  .successStories1Card {\n    height: 45vw;\n    width: 80vw;\n  }\n\n  .successStories1Card_list {\n    font-size: 1.7vw;\n  }\n  .successStories1Card .ant-card-head-title {\n    font-size: 2vw;\n    line-height: 2.5vw;\n  }\n  ul.successStories1Card_list li {\n    list-style: none;\n    margin-bottom: 10px;\n    line-height: 2.2vw;\n  }\n}\n\n@media only screen and (min-width: 1026px) and (max-width: 1388px) {\n  .successStories1Card {\n    height: 55vh;\n    width: 100vw;\n  }\n\n  .successStories1Card_list {\n    font-size: 1.4vw;\n    line-height: 1.7vw;\n    padding: 0vw 2vw;\n  }\n  .successStories1Card .ant-card-head-title {\n    font-size: 2vw;\n    line-height: 2vw;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
